import { render } from "./UserIntroduce.vue?vue&type=template&id=0ea43cc1&scoped=true"
import script from "./UserIntroduce.vue?vue&type=script&lang=js"
export * from "./UserIntroduce.vue?vue&type=script&lang=js"

import "./UserIntroduce.vue?vue&type=style&index=0&id=0ea43cc1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea43cc1"]])

export default __exports__